import React from 'react';

/** ページ上部には操作と文脈情報だけを置き、画面名の可視表示はナビゲーションへ委ねる。 */
export default function StickyPageTopbar({ title, children, actions, className = '' }) {
  const hasChildren = React.Children.toArray(children).length > 0;
  const hasActions = React.Children.toArray(actions).length > 0;
  return (
    <>
      {title ? <h2 className="visually-hidden">{title}</h2> : null}
      {hasChildren || hasActions ? (
        <header className={['page-topbar', className].filter(Boolean).join(' ')}>
          {hasChildren ? <div className="page-topbar__left">{children}</div> : null}
          {hasActions ? <div className="page-topbar__actions">{actions}</div> : null}
        </header>
      ) : null}
    </>
  );
}
